var map = {
	"./GSL1.webp": 322,
	"./GSL1b (2).webp": 6131,
	"./GSL1b.webp": 3091,
	"./GSL2.webp": 8668,
	"./GSL3.webp": 9990,
	"./GSL3a.webp": 106,
	"./GSL3b.webp": 4071,
	"./GSL3c.webp": 2510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5732;